import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 16px;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #0384ac;
`;
